export default __webpack_public_path__ + "static/media/splash1500.e424518f.jpg";